<template>
  <div>
    <v-card>
      <v-tabs v-model="tab" color="primary">
        <v-tab>
          <v-icon left>mdi-cloud-upload</v-icon> Precargar guías
        </v-tab>
        <v-tab>
          <v-icon left>mdi-history</v-icon> Estado de precargas
        </v-tab>
        <v-tab>
          <v-icon left>mdi-microsoft-excel</v-icon> Archivos VIDA18
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- Tab 1: precargar guias -->
        <v-tab-item>
          <v-toolbar flat color="white" class="mt-4">
            <v-col cols="2">
              <v-text-field
                type="date"
                label="Desde"
                v-model="fechaDesde"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                type="date"
                label="Hasta"
                v-model="fechaHasta"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Buscar por guía"
                v-model="busAwb"
                clearable
                prepend-icon="mdi-magnify"
                @keyup.enter="cargarListaGuias"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn small color="blue" dark @click="cargarListaGuias">
              <v-icon left>mdi-magnify</v-icon> Consultar
            </v-btn>
          </v-toolbar>

          <v-data-table
            :headers="headersGuias"
            :items="listaGuias"
            :loading="loadingTable"
            :items-per-page="itemsPerPage"
            item-key="CABECERA_ID"
            class="elevation-1"
            dense
          >
            <template v-slot:item.completa="{ item }">
              <v-chip small :color="item.completa ? 'green' : 'grey'" dark>
                {{ item.completa ? "Completa" : "Incompleta" }}
              </v-chip>
            </template>
            <template v-slot:item.precarga_estado="{ item }">
              <v-chip small :color="colorEstado(item.precarga_estado)" dark>{{
                item.precarga_estado
              }}</v-chip>
            </template>
            <template v-slot:item.auditoria="{ item }">
              <v-chip small dark :color="item.audit_completa ? 'green' : 'orange'">
                {{
                  item.audit_completa
                    ? "Completa"
                    : "Pendiente (" + item.audit_verificadas + "/" + item.audit_total + ")"
                }}
              </v-chip>
            </template>
            <template v-slot:item.opciones="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <!-- <v-btn
                    v-on="on"
                    icon
                    small
                    color="blue"
                    @click="verificarGuia(item)"
                  >
                    <v-icon>mdi-clipboard-check-outline</v-icon>
                  </v-btn> -->
                </template>
                <span>Verificar guía master</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    small
                    color="teal"
                    @click="abrirAuditoria(item)"
                  >
                    <v-icon>mdi-barcode-scan</v-icon>
                  </v-btn>
                </template>
                <span>Auditar cajas</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    small
                    color="green"
                    :disabled="!item.completa || !item.audit_completa"
                    :loading="item.enviando"
                    @click="enviarPrecarga(item)"
                  >
                    <v-icon>mdi-cloud-upload</v-icon>
                  </v-btn>
                </template>
                <span>{{
                  item.completa && item.audit_completa
                    ? "Enviar precarga"
                    : !item.audit_completa
                    ? "Auditoría de códigos incompleta"
                    : "Guía master incompleta"
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-tab-item>

        <!-- Tab 2: estado de precargas -->
        <v-tab-item>
          <v-toolbar flat color="white">
            <v-col cols="3">
              <v-select
                label="Estado"
                v-model="busEstado"
                clearable
                :items="estadosPrecarga"
                item-text="descripcion"
                item-value="valor"
                @change="cargarEstados"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Buscar por guía"
                v-model="busAwbEstado"
                clearable
                prepend-icon="mdi-magnify"
                @keyup.enter="cargarEstados"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn small color="blue" dark @click="cargarEstados">
              <v-icon left>mdi-refresh</v-icon> Actualizar
            </v-btn>
          </v-toolbar>

          <v-data-table
            :headers="headersEstados"
            :items="listaEstados"
            :loading="loadingTable"
            :items-per-page="itemsPerPage"
            item-key="ID"
            class="elevation-1"
            dense
          >
            <template v-slot:item.ESTADO="{ item }">
              <v-chip small :color="colorEstado(item.ESTADO)">{{
                item.ESTADO
              }}</v-chip>
            </template>
            <template v-slot:item.opciones="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    small
                    color="blue"
                    @click="verRespuesta(item)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>Ver respuesta</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    small
                    color="orange"
                    :disabled="item.ESTADO !== 'ERROR'"
                    :loading="item.reintentando"
                    @click="reintentar(item)"
                  >
                    <v-icon>mdi-restore</v-icon>
                  </v-btn>
                </template>
                <span>Reintentar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-tab-item>

        <!-- Tab 3: archivos VIDA18 (desde la coordinación, no requiere pesos ni medidas) -->
        <v-tab-item>
          <v-toolbar flat color="white" class="mt-4">
            <v-col cols="2">
              <v-text-field
                type="date"
                label="Desde"
                v-model="fechaDesdeVida18"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                type="date"
                label="Hasta"
                v-model="fechaHastaVida18"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Buscar por guía"
                v-model="busAwbVida18"
                clearable
                prepend-icon="mdi-magnify"
                @keyup.enter="cargarGuiasVida18"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn small color="blue" dark @click="cargarGuiasVida18">
              <v-icon left>mdi-magnify</v-icon> Consultar
            </v-btn>
            <v-btn
              small
              color="green darken-3"
              dark
              class="ml-2"
              :loading="generandoMaestrosVida18"
              @click="descargarMaestrosVida18"
            >
              <v-icon left>mdi-file-table-box-multiple</v-icon> Descargar maestros
            </v-btn>
          </v-toolbar>

          <v-data-table
            :headers="headersVida18"
            :items="listaVida18"
            :loading="loadingTable"
            :items-per-page="itemsPerPage"
            item-key="CABECERA_ID"
            class="elevation-1"
            dense
          >
            <template v-slot:item.vida18_fecha="{ item }">
              <v-chip small dark :color="item.vida18_fecha ? 'green' : 'grey'">
                {{
                  item.vida18_fecha
                    ? "Generado " + fechaCorta(item.vida18_fecha) + (item.vida18_generado_por ? " - " + item.vida18_generado_por : "")
                    : "Pendiente"
                }}
              </v-chip>
            </template>
            <template v-slot:item.opciones="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    small
                    color="green darken-3"
                    :loading="item.generandoVida18"
                    @click="generarVida18(item)"
                  >
                    <v-icon>mdi-microsoft-excel</v-icon>
                  </v-btn>
                </template>
                <span>Generar archivo VIDA18</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog v-model="dialogRespuesta" width="900" scrollable>
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>
            Respuesta de precarga
            <span v-if="detalle && detalle.ID"> #{{ detalle.ID }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-chip
            v-if="detalle && detalle.ESTADO"
            small
            dark
            :color="colorEstado(detalle.ESTADO)"
            outlined
            class="mr-2"
          >
            {{ detalle.ESTADO }}
          </v-chip>
          <v-btn
            @click="copiarRespuesta"
            small
            dark
            class="mr-2"
          >
            <v-icon left>mdi-content-copy</v-icon> Copiar
          </v-btn>
          <v-btn @click="dialogRespuesta = false" small icon dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-subtitle v-if="detalle" class="body-2">
          <div>
            AWB: <b>{{ detalle.AWB }}</b>
            <span v-if="detalle.NUM_GUIA_FINCA">
              &nbsp;|&nbsp; Guía: <b>{{ detalle.NUM_GUIA_FINCA }}</b>
            </span>
            <span v-if="detalle.CABECERA_ID">
              &nbsp;|&nbsp; CABECERA_ID: <b>{{ detalle.CABECERA_ID }}</b>
            </span>
          </div>
          <div>
            Enviado: <b>{{ detalle.FECHA_ENVIO }}</b>
            <span v-if="detalle.ENVIADO_POR">
              &nbsp;|&nbsp; Por: <b>{{ detalle.ENVIADO_POR }}</b>
            </span>
          </div>
        </v-card-subtitle>

        <v-card-text>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Respuesta del API de EGL
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <pre class="body-2 pre-detalle">{{ detalleRespuesta }}</pre>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>
                XML enviado
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <pre class="body-2 pre-detalle">{{ detalleXml }}</pre>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>

    <auditoria-cajas-dialog
      v-model="dialogAuditoria"
      :cabecera-id="auditGuia.CABECERA_ID"
      :awb="auditGuia.AWB"
      :fecha="auditGuia.FECHA"
      :cliente="auditGuia.CLIENTE"
      @actualizado="cargarListaGuias"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import AuditoriaCajasDialog from "./AuditoriaCajasDialog.vue";

export default {
  name: "PrecargaEgl",
  components: { AuditoriaCajasDialog },
  data() {
    return {
      tab: 0,
      itemsPerPage: 20,
      busAwb: "",
      busEstado: "",
      busAwbEstado: "",
      fechaDesde: "",
      fechaHasta: "",
      listaGuias: [],
      listaEstados: [],
      estadosPrecarga: [
        { valor: "REALIZADA", descripcion: "Realizada" },
        { valor: "PENDIENTE", descripcion: "Pendiente" },
        { valor: "ERROR", descripcion: "Error" },
      ],
      headersGuias: [
        { text: "AWB", value: "AWB" },
        { text: "Fecha", value: "FECHA" },
        { text: "Cliente", value: "CLIENTE" },
        { text: "Hijas", value: "num_hijas" },
        { text: "Piezas", value: "num_cajas" },        
        { text: "Estado", value: "completa" },
        { text: "Precarga", value: "precarga_estado" },
        { text: "Auditoría", value: "auditoria" },
        { text: "Acciones", value: "opciones", sortable: false },
      ],
      headersVida18: [
        { text: "AWB", value: "AWB" },
        { text: "Fecha", value: "FECHA" },
        { text: "Hijas", value: "NUM_HIJAS" },
        { text: "Piezas coordinadas", value: "NUM_PIEZAS" },
        { text: "VIDA18", value: "vida18_fecha" },
        { text: "Acciones", value: "opciones", sortable: false },
      ],
      listaVida18: [],
      fechaDesdeVida18: "",
      fechaHastaVida18: "",
      busAwbVida18: "",
      generandoMaestrosVida18: false,
      headersEstados: [
        { text: "ID", value: "ID" },
        { text: "AWB", value: "AWB" },
        { text: "Guía", value: "NUM_GUIA_FINCA" },
        { text: "Estado", value: "ESTADO" },
        { text: "Fecha envío", value: "FECHA_ENVIO" },
        { text: "Enviado por", value: "ENVIADO_POR" },
        { text: "Registrado", value: "FECHA" },
        { text: "Acciones", value: "opciones", sortable: false },
      ],
      dialogRespuesta: false,
      detalle: null,
      detalleRespuesta: "",
      detalleXml: "",
      dialogAuditoria: false,
      auditGuia: { CABECERA_ID: null, AWB: null, FECHA: null, CLIENTE: null },
    };
  },
  computed: {
    ...mapState("master", ["loadingTable", "user"]),
  },
  methods: {
    ...mapMutations("master", ["setUrl", "setLoadingTable", "setTitleToolbar"]),
    ...mapActions("master", ["requestApi", "alertNotification"]),

    colorEstado(estado) {
      if (estado === "REALIZADA") return "green";
      if (estado === "ERROR") return "red";
      return "orange";
    },

    toIsoDate(date) {
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return date.getFullYear() + "-" + m + "-" + d;
    },

    cargarListaGuias() {
      this.setLoadingTable(true);
      this.setUrl("api/lista-precarga-egl");
      this.requestApi({
        method: "GET",
        data: {
          busAwb: this.busAwb,
          fechaDesde: this.fechaDesde,
          fechaHasta: this.fechaHasta,
        },
      })
        .then((res) => {
          this.listaGuias = res.data.lista;
        })
        .catch(() => {})
        .finally(() => this.setLoadingTable(false));
    },

    verificarGuia(item) {
      this.setUrl("api/verificar-precarga-egl");
      this.requestApi({
        method: "POST",
        data: { CABECERA_ID: item.CABECERA_ID },
      })
        .then((res) => {
          const ok = res.data.success;
          this.alertNotification({
            param: {
              html: res.data.msg,
              icon: ok ? "success" : "error",
              title: ok ? "Correcto" : "Guía master no lista",
            },
          });
        })
        .catch((err) => {
          this.alertNotification({
            param: { html: (err.response && err.response.data.msg) || "Error al verificar", icon: "error", title: "Error" },
          });
        });
    },

    enviarPrecarga(item) {
      this.$set(item, "enviando", true);
      this.setUrl("api/enviar-precarga-egl");
      this.requestApi({
        method: "POST",
        data: { CABECERA_ID: item.CABECERA_ID },
      })
        .then((res) => {
          this.alertNotification({
            param: {
              html: res.data.msg,
              icon: res.data.success ? "success" : "error",
              title: res.data.success ? "Correcto" : "Error",
            },
          });
          this.cargarListaGuias();
          this.cargarEstados(true);
        })
        .catch((err) => {
          this.alertNotification({
            param: { html: (err.response && err.response.data.msg) || "Error al enviar", icon: "error", title: "Error" },
          });
        })
        .finally(() => this.$set(item, "enviando", false));
    },

    cargarEstados(recargar) {
      if (!recargar) this.setLoadingTable(true);
      this.setUrl("api/estado-precarga-egl");
      this.requestApi({
        method: "GET",
        data: { estado: this.busEstado, busAwb: this.busAwbEstado },
      })
        .then((res) => {
          this.listaEstados = res.data.lista;
        })
        .catch(() => {})
        .finally(() => this.setLoadingTable(false));
    },

    verRespuesta(item) {
      this.setUrl("api/detalle-precarga-egl");
      this.requestApi({ method: "GET", data: { ID: item.ID } })
        .then((res) => {
          this.detalle = res.data.detalle || null;
          this.detalleRespuesta = this.detalle ? this.detalle.RESPUESTA || "Sin respuesta" : "Sin datos";
          this.detalleXml = this.detalle ? this.detalle.XML || "Sin XML" : "";
          this.dialogRespuesta = true;
        })
        .catch((err) => {
          this.alertNotification({
            param: { html: (err.response && err.response.data.msg) || "Error al obtener el detalle", icon: "error", title: "Error" },
          });
        });
    },

    copiarRespuesta() {
      if (!this.detalleRespuesta) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.detalleRespuesta);
      } else {
        const ta = document.createElement("textarea");
        ta.value = this.detalleRespuesta;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      this.alertNotification({
        param: { html: "Respuesta copiada al portapapeles", icon: "success", title: "Copiado" },
      });
    },

    reintentar(item) {
      this.$set(item, "reintentando", true);
      this.setUrl("api/reintentar-precarga-egl");
      this.requestApi({
        method: "POST",
        data: { PRECARGA_ID: item.ID },
      })
        .then((res) => {
          this.alertNotification({
            param: {
              html: res.data.msg,
              icon: res.data.success ? "success" : "error",
              title: res.data.success ? "Correcto" : "Error",
            },
          });
          this.cargarEstados();
          this.cargarListaGuias();
        })
        .catch((err) => {
          this.alertNotification({
            param: { html: (err.response && err.response.data.msg) || "Error al reintentar", icon: "error", title: "Error" },
          });
        })
        .finally(() => this.$set(item, "reintentando", false));
    },

    fechaCorta(fecha) {
      const p = String(fecha).substring(0, 10).split("-");
      return p.length === 3 ? p[2] + "/" + p[1] : fecha;
    },

    generarVida18(item) {
      this.$set(item, "generandoVida18", true);
      this.setUrl("api/generar-archivo-vida18");
      this.requestApi({
        method: "POST",
        data: { CABECERA_ID: item.CABECERA_ID },
      })
        .then((res) => {
          if (!res.data.success) {
            this.alertNotification({
              param: {
                html: res.data.msg,
                icon: "error",
                title: "No se puede generar el archivo",
              },
            });
            return;
          }
          const a = document.createElement("a");
          a.href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
            res.data.datos;
          a.download = res.data.archivo;
          a.click();
          this.cargarGuiasVida18(true);
        })
        .catch((err) => {
          this.alertNotification({
            param: { html: (err.response && err.response.data.msg) || "Error al generar el archivo", icon: "error", title: "Error" },
          });
        })
        .finally(() => this.$set(item, "generandoVida18", false));
    },

    descargarMaestrosVida18() {
      this.generandoMaestrosVida18 = true;
      this.setUrl("api/maestros-archivo-vida18");
      this.requestApi({ method: "POST", data: {} })
        .then((res) => {
          const a = document.createElement("a");
          a.href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
            res.data.datos;
          a.download = res.data.archivo;
          a.click();
        })
        .catch((err) => {
          this.alertNotification({
            param: { html: (err.response && err.response.data.msg) || "Error al generar los maestros", icon: "error", title: "Error" },
          });
        })
        .finally(() => (this.generandoMaestrosVida18 = false));
    },

    cargarGuiasVida18(recargar) {
      if (recargar !== true) this.setLoadingTable(true);
      this.setUrl("api/lista-archivo-vida18");
      this.requestApi({
        method: "GET",
        data: {
          busAwb: this.busAwbVida18,
          fechaDesde: this.fechaDesdeVida18,
          fechaHasta: this.fechaHastaVida18,
        },
      })
        .then((res) => {
          this.listaVida18 = res.data.lista;
        })
        .catch(() => {})
        .finally(() => this.setLoadingTable(false));
    },

    abrirAuditoria(item) {
      this.auditGuia = {
        CABECERA_ID: item.CABECERA_ID,
        AWB: item.AWB,
        FECHA: item.FECHA,
        CLIENTE: item.CLIENTE,
      };
      this.dialogAuditoria = true;
    },
  },
  mounted() {
    document.title = "Precarga EGL";
    this.setTitleToolbar("Precarga EGL");
    const hoy = new Date();
    const desde = new Date(hoy);
    desde.setDate(hoy.getDate() - 1);
    const hasta = new Date(hoy);
    hasta.setDate(hoy.getDate() + 6);
    this.fechaDesde = this.toIsoDate(desde);
    this.fechaHasta = this.toIsoDate(hasta);
    this.fechaDesdeVida18 = this.fechaDesde;
    this.fechaHastaVida18 = this.fechaHasta;
    this.cargarListaGuias();
    this.cargarEstados();
    this.cargarGuiasVida18();
  },
};
</script>

<style scoped>
.pre-detalle {
  max-height: 400px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
}
</style>